import React, { useEffect, useState } from 'react';
import {Carousel, Button, Modal} from 'react-bootstrap';
import axios from 'axios';
import './Gallery.css';

const config = require("../../config.json");

  const pageContainerStyle = {
    fontFamily: '"Inter", sans-serif',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#f8fafc', // Light grey background
    padding: '2rem 1rem',
  };

  const headerStyle = {
    fontSize: '2.5rem', // text-4xl
    fontWeight: '800', // font-extrabold
    color: '#3730a3', // indigo-900
    marginBottom: '2rem', // mb-8
    textAlign: 'center',
    textShadow: '3px 3px 6px rgba(0,0,0,0.1)',
  };

  const galleryGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', // Responsive columns
    gap: '1.5rem', // gap-6
    maxWidth: '1200px', // Max width for the gallery
    width: '100%',
    padding: '1rem',
  };

  const imageCardStyle = {
    backgroundColor: '#ffffff', // bg-white
    borderRadius: '1rem', // rounded-2xl
    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)', // shadow-lg
    overflow: 'hidden', // Ensures image corners are rounded
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    cursor: 'pointer',
  };

  const imageStyle = {
    width: '100%',
    height: '200px', // Fixed height for consistency
    objectFit: 'cover', // Ensures images fill the space without distortion
    display: 'block', // Remove extra space below image
  };

  const imageCaptionStyle = {
    padding: '1rem',
    fontSize: '1.125rem', // text-lg
    fontWeight: '600', // font-semibold
    color: '#4f46e5', // indigo-700
    textAlign: 'center',
  };



export default function GalleryMain(){
  const [showModal, setShowModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  const handleViewClick = (post) => {
    console.log("post:", post);
    setSelectedPost(post);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPost(null);
  };

   const fetchGalleryImages =async()=>{
    try{
        setLoaded(false);
        const fileName='images/gallery/';
        const bucketName="images.archivesj.in";
    await axios.get(`${config.api.invokeURL}/dashboard/website/gallery?fileName=${fileName}&bucketName=${bucketName}`,{
        headers: {
          //Authorization: access_token,
          'x-api-key': config.api.key
        }}, 
    ).then((response)=>{
        console.log(response.data);
        processGalleryData(response.data);
        //setGalleryImages(response.data);
        //enqueueSnackbar(response.data.length + " - Project Images are available",{variant:'success'});
        //setLoaded(true);
        //setDispMsg(response.data.length + " - Images are found in your Gallery");
    }).catch((error)=>{
        //console.log(error.message);
        //enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);
        //window.scrollTo(0,0);   
        //setDispMsg(error.message);
    })
  }catch(error){
  //console.log(error.message);
    //enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
    setLoaded(true);
    //window.scrollTo(0,0);   
    //setDispMsg(error.message);
  }
  }

  const processGalleryData=(item)=>{
    const test=[];
    for(const i in item){
        var testv={};
        testv=item[i];
        testv.length=item[i].fileName.length;
        testv.id=parseInt(i)+1;
        test.push(testv);
        testv={};
    }
    console.log("testdata :", test);
    setGalleryImages(test);
    setLoaded(true);
  }

  return (
    <div className="container-fluid py-5 bg-light " style={pageContainerStyle}>
      <div className="container">
        <div className="text-center mb-4">
          <p  style={headerStyle} className=" px-5"><span className="px-2 ">Our Gallery</span></p>
          <h1 className="mb-4">Latest Events & Updates</h1>
        </div>

        <div className="row" style={galleryGridStyle}>
          {galleryImages.map((post,id) => (
            <div className="" key={id}>
              <div  style={imageCardStyle}>
                {/* Carousel for multiple images */}
                <Carousel
                  className="blog-carousel"
                  interval={3500}
                  controls={post.fileName.length > 1}
                  indicators={post.fileName.length > 1}
                  fade={true}
                  prevIcon={<span className="carousel-icon"><i className="fa fa-chevron-left"></i></span>}
                  nextIcon={<span className="carousel-icon"><i className="fa fa-chevron-right"></i></span>}
                >
                  {post.fileName.map((img, idx) => (
                    <Carousel.Item key={idx}>
                      <img
                        src={`${config.s3.imageUrl}${img}`}
                        className="d-block w-100"
                        alt={post.projectName + ' - ' + (idx + 1)}
                        style={{ height: '250px', objectFit: 'cover' }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>

                {/* Card content */}
                <div className="card-body">
                  <h5 style={imageCaptionStyle}>{post.projectName}</h5>
                  {/*<p className="card-text">{post.excerpt}</p>*/}
                  <Button variant="primary" onClick={() => handleViewClick(post)}>
                    VIEW
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/*<div className="row">
          {posts.map(post => (
            <div className="col-md-4 mb-4" key={post.id}>
              <div className="card border-0 shadow-sm h-100">
                {/* Carousel for multiple images //
                <Carousel
                  className="blog-carousel"
                  interval={3500}
                  controls={post.images.length > 1}
                  indicators={post.images.length > 1}
                  fade={true}
                  prevIcon={<span className="carousel-icon"><i className="fa fa-chevron-left"></i></span>}
                  nextIcon={<span className="carousel-icon"><i className="fa fa-chevron-right"></i></span>}
                >
                  {post.images.map((img, idx) => (
                    <Carousel.Item key={idx}>
                      <img
                        src={img}
                        className="d-block w-100"
                        alt={post.title + ' - ' + (idx + 1)}
                        style={{ height: '250px', objectFit: 'cover' }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>

                {/* Card content //
                <div className="card-body">
                  <h5 className="card-title">{post.title}</h5>
                  <p className="card-text">{post.excerpt}</p>
                  <Button variant="primary" onClick={() => handleViewClick(post)}>
                    VIEW
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>*/}
      </div>

      {/* Fullscreen Modal with Carousel */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        fullscreen={true}
        className="blog-fullscreen-modal"
        dialogClassName="modal-fullscreen"
        contentClassName="modal-content-fullscreen"
      >
        <Modal.Body className="blog-modal-body">
          {/* Close Button */}
          <button
            type="button"
            className="blog-close-btn"
            onClick={handleCloseModal}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          {selectedPost && (
            <div className="blog-modal-carousel-container">
              <h2 className="blog-modal-title">{selectedPost?.title}</h2>
              <Carousel
                className="blog-modal-carousel"
                interval={3500}
                controls={selectedPost.fileName.length > 1}
                indicators={selectedPost.fileName.length > 1}
                fade={true}
                prevIcon={<span className="carousel-icon"><i className="fa fa-chevron-left"></i></span>}
                nextIcon={<span className="carousel-icon"><i className="fa fa-chevron-right"></i></span>}
              >
                {selectedPost.fileName.map((img, idx) => (
                  <Carousel.Item key={idx}>
                    <img
                      src={`${config.s3.imageUrl}${img}`}
                      className="d-block mx-auto"
                      alt={selectedPost.title + ' - ' + (idx + 1)}
                      style={{ maxWidth: '95%', maxHeight: '90vh', objectFit: 'contain' }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}
